import {Routes, Route} from 'react-router-dom';
import './CSS/App.css';
import Home from './Pages/Home/Home';
import Navbar from './Pages/Shared/Navbar/Navbar';
import Footer from './Pages/Shared/Footer/Footer';
import Menu from './Pages/Menu/Menu';
import Contact from './Pages/Contact/Contact';
import Checkout from './Components/Checkout/Checkout';
import NotFound from './Pages/NotFound/NotFound';
import SignIn from './Pages/SignIn/SignIn';
import RequireAuth from './Components/RequireAuth';
import Success from './Components/Success/Success';

function App() {
  return (
    <div className="mt-16">
      <Navbar/>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/menu" element={<Menu/>} />
        <Route path="/contact" element={<Contact/>} />
        <Route path="/checkout/:id" element={<RequireAuth><Checkout/></RequireAuth>} />
        <Route path="/ssl-payment-success/:id" element={<RequireAuth><Success/></RequireAuth>} />
        <Route path="/signin" element={<SignIn/>} />
        <Route path="*" element={<NotFound/>} />
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
